<img
  [src]="'/assets/images/destination-icons/' + key + '.svg' | ssrEmptyString"
  alt="destination icon"
  *ngIf="key"
  corporateImageLazyLoad
/>
